import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Text from "sap/m/Text";

/**
 * @namespace vamos.cockpit.customcontrol.valuehelp
 */
export default class ValidatePropertyText extends Control {

    static readonly metadata: MetadataOptions = {
        properties: {
            expected: {
                type: "string",
                defaultValue: "",
            },
            actual: {
                type: "string",
                defaultValue: "",
            },
            text: {
                type: "string",
                defaultValue: "",
            },

        },
        aggregations: {
            _text: {
                type: "sap.m.Text",
                multiple: false,
                visibility: "hidden",
            },
        },
    };


    public setExpected(disabled: string) {
        this.setProperty("expected", disabled, true);
        this.checkExpected();
    }

    public setActual(actual: string) {
        this.setProperty("actual", actual, true);
        this.checkExpected();
    }

    public setText(text: string) {
        this.setProperty("text", text, true);
        (this.getAggregation("_text") as Text).setText(text);
    }

    private checkExpected(): void {
        const expected = this.getProperty("expected") as string;
        const actual = this.getProperty("actual") as string;
        const textControl = this.getAggregation("_text") as Text;
        textControl.addStyleClass("redCellBackground");
        if (expected === actual) {
            textControl.removeStyleClass("redCellBackground");
        }
    }

    public init(): void {

        this.setAggregation("_text", new Text({ renderWhitespace: false, wrapping: false }));
    };

    renderer = {
        apiVersion: 4,
        render: (rm: RenderManager, control: ValidatePropertyText) => {
            rm.renderControl(control.getAggregation("_text") as Control);
        },
    };
}